var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegenrate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    d: "M82,90c4.398,0,8-3.602,8-8.002V17.999c0-4.4-3.602-7.999-8-7.999H18c-4.398,0-8,3.599-8,7.999v63.999 c0,4.4,3.602,8.002,8,8.002H82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4E3F9",
    d: "M46.536,19.999l-4.714,4.713l5.395,5.395c-10.202,0.561-18.678,7.645-21.24,17.189l-3.863-1.036 c2.353-8.767,8.809-15.58,17.043-18.556l-2.993-2.992l7.543-7.541L46.536,19.999z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2CABE1",
    d: "M57.514,30.976L46.536,19.999l-4.714,4.713l5.395,5.395c-10.202,0.561-18.678,7.645-21.24,17.189l6.48,1.738 c1.781-6.627,7.517-11.602,14.525-12.242l-5.156,5.16l4.713,4.713l10.975-10.977C58.814,34.391,58.814,32.276,57.514,30.976z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0077BD",
    d: "M33.974,45.301c-0.646,1.166-1.163,2.415-1.517,3.733l-6.48-1.738c0.351-1.308,0.823-2.564,1.385-3.77 L33.974,45.301z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4E3F9",
    d: "M53.922,79.18C51.994,79.697,49.977,80,47.887,80c-8.167,0-15.303-4.266-19.47-10.643l-1.979,7.393 L20,75.025l-1.035,3.863l10.302,2.761l1.097-4.097C35.22,81.674,41.388,84,47.887,84c2.326,0,4.705-0.322,7.072-0.957L53.922,79.18z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0077BD",
    d: "M43.257,30.673c1.284-0.295,2.605-0.491,3.959-0.566l0,0l3.224,3.225l-3.459,3.461l0,0 c-2.371,0.217-4.59,0.939-6.566,2.045l5.501-5.505L43.257,30.673z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4E3F9",
    d: "M80,71.641l-1.727-6.439l-7.363,1.973c1.635-3.152,2.578-6.713,2.578-10.508 c0-6.434-2.617-12.267-6.842-16.491l2.828-2.828c5.168,5.167,8.014,12.028,8.014,19.319c0,1.597-0.139,3.17-0.416,4.715l4.029-1.079 l2.763,10.303L80,71.641z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2CABE1",
    d: "M52.188,72.701c-1.381,0.371-2.807,0.631-4.301,0.631c-5.608,0-10.533-2.813-13.531-7.082l7.013,1.877 l1.724-6.438L28.1,57.672c-1.776-0.479-3.606,0.58-4.082,2.357L20,75.025l6.438,1.725l1.979-7.393C32.583,75.734,39.72,80,47.887,80 c2.09,0,4.107-0.303,6.035-0.82L52.188,72.701z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2CABE1",
    d: "M78.273,65.201l-7.363,1.973c1.635-3.152,2.578-6.713,2.578-10.508c0-6.434-2.617-12.267-6.842-16.491 l-4.713,4.709c3.02,3.019,4.889,7.19,4.889,11.782c0,2.49-0.609,4.813-1.605,6.918l-1.875-7l-6.438,1.727l4.018,14.994 c0.477,1.775,2.305,2.83,4.082,2.355L80,71.641L78.273,65.201z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0077BD",
    d: "M48.192,73.252c1.333-0.023,2.673-0.201,3.993-0.554l1.734,6.481c-1.309,0.35-2.632,0.57-3.957,0.686 L48.192,73.252z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0077BD",
    d: "M30.882,72.525c-0.897-0.965-1.728-2.01-2.47-3.146l0,0l1.18-4.404l4.727,1.265l0,0 c1.374,1.945,3.109,3.506,5.054,4.664l-7.518-2.011L30.882,72.525z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0077BD",
    d: "M64.368,48.112c-0.687-1.143-1.511-2.215-2.476-3.181l4.746-4.743c0.957,0.959,1.81,1.994,2.571,3.084 L64.368,48.112z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0077BD",
    d: "M72.394,63.466c-0.386,1.259-0.876,2.501-1.489,3.712l0,0l-4.403,1.18l-1.269-4.726l0,0 c0.997-2.161,1.481-4.445,1.513-6.709l2.018,7.517L72.394,63.466z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenrate);
export default __webpack_public_path__ + "static/media/regenrate.1260bd8809789270cc486ce03b9c3543.svg";
export { ForwardRef as ReactComponent };